import { Trans, useTranslation } from 'react-i18next';
import { MARKET } from '@/common/constants/markets';
import {
  TInsuranceAvailablePlan,
  TInsuranceCoverage,
  TInsurancePerson,
} from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { TMenhirInsurancePaymentMethod } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { Row } from '@/web/components/Row/Row';
import { InsuranceUpgradePlanCostSummaryTable } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsuranceUpgradePlanSummaryStep/components/InsuranceUpgradePlanCostSummaryTable/InsuranceUpgradePlanCostSummaryTable';
import { InsuranceUpgradePlanFAQs } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/common/InsuranceUpgradePlanFAQs/InsuranceUpgradePlanFAQs';
import { useMarket } from '@/web/hooks/useMarket';
import { PageLayout } from '@/web/layouts/PageLayout/PageLayout';
import { Card, Text } from '@coverflex-tech/hypernova';

export const InsuranceUpgradePlanSummaryStep = ({
  planName,
  persons,
  selectedPlan,
  coverages = [],
  paymentMethod,
}: TInsuranceUpgradePlanPaymentMethodStepProps) => {
  const { t } = useTranslation();
  const { slug } = useMarket();

  return (
    <PageLayout>
      <Card plain variant="new">
        <InsuranceUpgradePlanCostSummaryTable
          persons={persons}
          exemptions={selectedPlan?.metadata?.exemptionAmount}
        >
          {paymentMethod && (
            <Text>
              <Trans
                i18nKey={`dashboard.insurance.upgrade_plan.step.confirm_details.payment_method.${paymentMethod}`}
              />
            </Text>
          )}
        </InsuranceUpgradePlanCostSummaryTable>
      </Card>
      <Card plain variant="new">
        <Text bold>{planName}</Text>
        <div>
          <Row
            start={
              <Text bold>
                {t('dashboard.insurance.upgrade_plan.card.coverages_title')}
              </Text>
            }
          />
          {coverages.map((coverage, idx) => (
            <Row
              key={idx}
              start={<Text>{coverage.name}</Text>}
              end={<Text bold>{coverage.value}</Text>}
            />
          ))}
        </div>
      </Card>
      <InsuranceUpgradePlanFAQs
        title={
          <Trans i18nKey="dashboard.insurance.upgrade_plan.step.confirm_details.faqs.title" />
        }
        faqsI18nKey={
          slug === MARKET.ES
            ? 'dashboard.insurance.es.available_plan.step.confirm_details.faqs.list'
            : `dashboard.insurance.upgrade_plan.step.confirm_details.faqs.${paymentMethod}.list`
        }
        plan={selectedPlan}
      />
    </PageLayout>
  );
};

export type TInsuranceUpgradePlanPaymentMethodStepProps = {
  planName?: string;
  selectedPlan?: TInsuranceAvailablePlan;
  persons?: TInsurancePerson[];
  coverages?: TInsuranceCoverage[];
  paymentMethod?: TMenhirInsurancePaymentMethod;
};
